import { createFileRoute } from "@tanstack/react-router"
import { LegalPage } from "@/components/legal/legal-page"

export const Route = createFileRoute("/privacy")({ component: Privacy })

function Privacy() {
  return (
    <LegalPage title="Privacy policy" updated="17 September 2026">
      <p>
        Vienna is a customer messaging workspace operated by the business that runs this installation. It connects the business's own Instagram professional accounts and Facebook Pages so the team can read and answer customer messages and comments from one place. This policy describes what the software stores and why.
      </p>
      <h2>What we receive from Meta</h2>
      <p>When a member of the team connects an Instagram account or Facebook Page, Meta sends Vienna:</p>
      <ul>
        <li>Direct messages, story replies, comments and reactions that customers send to those accounts, including attachments.</li>
        <li>Delivery and read receipts for messages the business sends.</li>
        <li>The public profile name, username and picture of people who message or comment.</li>
        <li>Access tokens for the connected Pages, so the business can reply. Tokens are encrypted and can only be used by the messaging service.</li>
      </ul>
      <h2>How it is used</h2>
      <ul>
        <li>Showing conversations to the team and letting them reply, assign and resolve them.</li>
        <li>Automated replies the business has set up, such as answering a comment keyword with a private message. A person can take over any conversation at any time.</li>
        <li>Campaign messages sent only to people who gave the business permission to receive them, within Meta's messaging rules.</li>
        <li>Reports about response times and delivery. These contain counts, not message content.</li>
      </ul>
      <p>Data is not sold and is not shared with anyone outside the business, other than the infrastructure providers that host the software.</p>
      <h2>Retention and deletion</h2>
      <ul>
        <li>Raw webhook deliveries are kept for seven days; conversation history is kept while the business account exists.</li>
        <li>A customer can ask the business to delete their data. The team records the request and a second, permission-gated step removes the person, their messages and comments, and leaves a marker so later deliveries do not recreate them.</li>
        <li>If the person who connected a Page removes Vienna from their Facebook settings, or asks Meta to delete their data, the connection is revoked and the stored tokens are erased. The status of such a request can be checked at the link Meta provides.</li>
      </ul>
      <h2>Contact</h2>
      <p>Questions about this policy go to the business operating this workspace. Their contact details are shown inside the workspace settings.</p>
    </LegalPage>
  )
}
